import SmsOutlinedIcon from "@mui/icons-material/SmsOutlined";
import { Grid } from "@mui/material";
import { Bar } from "react-chartjs-2";
import { useTranslation } from "react-i18next";
import Label from "../../component/Label";
import TypographyLabel from "../../component/Typography";

export default function Sms(props: any) {
  const { smsConsumeAndBalance } = props;
  const { t } = useTranslation();

  const months = Object.keys(smsConsumeAndBalance);

  const totalSMSConsumed = months.reduce((total, item) => {
    const smsBalance = smsConsumeAndBalance[item]?.["SMS Balance"] || 0;
    return smsBalance;
  }, 0);

  const chartdata = {
    labels: months,
    datasets: [
      {
        data: months.map(
          (item) => smsConsumeAndBalance[item]?.["SMS Consumed"]
        ),
        backgroundColor: "#FF8F8F",
        borderRadius: 10,
        barThickness: 35,
        maxBarThickness: 40,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: "top" as const,
      },
    },
  };

  return (
    <div className="sms">
      <Grid
        container
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        className="padding-left-10"
      >
        <Grid item xs={8}>
          <div className=" dashboard-heading padding-y-10 padding20">
            <Label title={t("smsConsumed")} />
          </div>
          <Bar options={options} data={chartdata} />
        </Grid>
        <Grid item xs={4}>
          <div className="  balance-box ">
            <div className="padding20 active-box ">
              <div className=" sms-icon">
                <SmsOutlinedIcon />
              </div>

              <div className="active-title padding-y-10">
                {" "}
                {totalSMSConsumed}
              </div>
              <Label title={t("sms")} />
              <div className="active-small-title">
                <TypographyLabel title={t("balanced")} />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}
